(ns frontend.test.drop-tray.view
  "The test page of the drop tray. It shows the two targets at rest, with a card over
   them and while a drop settles on them, and a small board where a card can be dragged
   to the targets. Compare it with the tray of the Dealflow page of the UX mockup."
  (:require
   [reagent.core :as r]
   [ui.components.drop-tray.view :as drop-tray]
   [ui.dom-globals :as dg]))

(defonce state*
  (r/atom {:over nil
           :last nil}))

(defn- section
  [{:keys [title]} & children]
  (into [:div {:class "tw2-space-y-2"}
         [:h2 {:class "tw2-text-sm tw2-font-semibold tw2-text-slate-700"} title]]
        children))

(defn- tray-row
  [{:keys [active-on-hold? active-lost? absorbing-on-hold? absorbing-lost?]}]
  [drop-tray/view
   {:message "Drop to set the outcome. The stage does not change."}
   [:div {:class "tw2-flex tw2-w-full tw2-gap-3"}
    [drop-tray/on-hold-target
     {:active?    active-on-hold?
      :absorbing? absorbing-on-hold?}]
    [drop-tray/lost-target
     {:active?    active-lost?
      :absorbing? absorbing-lost?}]]])

(defn- target-handlers
  [target]
  {:on-drag-over  (fn [e]
                    (dg/prevent-default e)
                    (swap! state* assoc :over target))
   :on-drag-leave (fn [_]
                    (swap! state* assoc :over nil))
   :on-drop       (fn [e]
                    (dg/prevent-default e)
                    (swap! state* assoc :over nil :last target))})

(defn view
  []
  (let [{:keys [over last]} @state*]
    [:div {:class "tw2 tw2-min-h-screen tw2-bg-white tw2-p-8"}
     [:div {:class "tw2-mx-auto tw2-max-w-[640px] tw2-space-y-6"}
      [:h1 {:class "tw2-text-3xl tw2-font-semibold tw2-text-slate-950"}
       "Drop Tray Playground"]
      [:p {:class "tw2-text-sm tw2-text-slate-600"}
       "The drop tray of ZapKit. The tray does not know when it opens. The caller shows it while a card is dragged, and puts the targets in one row (flex, gap 12 px), as the ZapKit story does."]
      [section {:title "At rest"}
       [tray-row {}]]
      [section {:title "A card is over the on-hold target (active)"}
       [tray-row {:active-on-hold? true}]]
      [section {:title "A card is over the lost target (active)"}
       [tray-row {:active-lost? true}]]
      [section {:title "The drop settles on the on-hold target (absorbing)"}
       [tray-row {:absorbing-on-hold? true}]]
      [section {:title "Drag the card to a target"}
       [:div
        {:class     "tw2-w-[240px] tw2-cursor-grab tw2-rounded-lg tw2-border tw2-border-slate-300 tw2-bg-white tw2-p-3 tw2-text-sm"
         :draggable true}
        "A deal card"]
       [drop-tray/view
        {:message "Drop to set the outcome. The stage does not change."}
        [:div {:class "tw2-flex tw2-w-full tw2-gap-3"}
         [drop-tray/on-hold-target
          (merge (target-handlers :on-hold)
                 {:active? (= over :on-hold)})]
         [drop-tray/lost-target
          (merge (target-handlers :lost)
                 {:active? (= over :lost)})]]]
       [:p {:class "tw2-text-sm tw2-text-slate-600"}
        (str "Last drop: " (or (some-> last name) "none"))]]]]))
